import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimaryMoisturiser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M16.889 7.412v6.9c0 .863-2.372 2.588-6.469 2.588s-6.469-1.725-6.469-2.587v-6.9m12.938 0V4.824m0 2.587s-1.51 1.294-6.469 1.294-6.469-1.294-6.469-1.294m12.938-2.587s-1.51 1.294-6.469 1.294-6.469-1.294-6.469-1.294m12.938 0c0-.863-1.94-1.725-6.469-1.725-4.528 0-6.469.862-6.469 1.725m0 0v2.587"
    />
  </svg>
);
export default SvgPrimaryMoisturiser;
